import { render, staticRenderFns } from "./pr_form.vue?vue&type=template&id=d54a5a78"
import script from "./pr_form.vue?vue&type=script&lang=js"
export * from "./pr_form.vue?vue&type=script&lang=js"
import style0 from "./pr_form.vue?vue&type=style&index=0&id=d54a5a78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports